function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M16,6h2v2h-2zM16,14.46002c-0.88,-0.06 -1.75,-0.21002 -2.59998,-0.46002l-1.20001,1.21002c1.20001,0.40997 2.47998,0.66998 3.79999,0.78998zM2,2c0.12,1.32001 0.38,2.59003 0.78998,3.79999l1.21002,-1.20996c-0.25,-0.84003 -0.40002,-1.71002 -0.46997,-2.59003zM18,13.5v3.5c0,0.54999 -0.45001,1 -1,1c-9.39001,0 -17,-7.60999 -17,-17c0,-0.54999 0.45001,-1 1,-1h3.5c0.5,0 1,0.45001 1,1c0,1.25 0.20001,2.45001 0.57001,3.57001c0.10999,0.34998 0.02997,0.73999 -0.25,1.01001l-2.20001,2.20996c1.44,2.83002 3.76001,5.14001 6.59003,6.58002l2.19995,-2.20001c0.20001,-0.16998 0.45001,-0.28998 0.71002,-0.28998c0.09998,0 0.21002,0.02002 0.31,0.04999c1.12,0.37 2.32001,0.57001 3.57001,0.57001c0.54999,0 1,0.5 1,1zM12,6h2v2h-2zM8,6h2v2h-2z",
  fill: "#b1c3cc",
  fillOpacity: 1
})));

var SvgCallHold = function SvgCallHold(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCallHold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/call_hold.2bebf504.svg";
export { ForwardRef as ReactComponent };